export enum StandardUserIds {
  SYSTEM = 'system',
  PRE_SIGNUP = 'presignup',
}

export enum StandardOrgIds {
  SYSTEM = 'system',
}

// File size threshold for using multipart upload
export const MULTIPART_UPLOAD_THRESHOLD = 100 * 1024 * 1024 // 100 MiB
export const MULTIPART_PART_SIZE = 100 * 1024 * 1024 // 100 MiB
export const MULTIPART_MIN_PART_SIZE = 5 * 1024 * 1024 // 5 MiB
export const MULTIPART_MAX_PARTS = 10000

// Asset download job S3 TTL
export const ASSET_DOWNLOAD_JOB_S3_TTL = 48 * 60 * 60 // 48 hours

/**
 * Expiry presets (in hours) a user can choose when creating an asset-set
 * share link: 24h, 7d, 30d, 90d. 90 days is the hard maximum — the
 * share-ZIP S3 lifecycle below assumes no link outlives it.
 */
export const SHARE_LINK_EXPIRY_PRESETS_HOURS = [24, 168, 720, 2160] as const

/**
 * S3 lifecycle expiry (days) for staged share ZIPs under `share-downloads/`.
 * 90d max link life + 7d grace so a ZIP built on day 0 outlives any link
 * that can reference it (a fresh job re-zips if the object is ever gone).
 */
export const ASSET_SHARE_DOWNLOAD_S3_TTL_DAYS = 97
